export const FETCH_RECIPES_USER = 'FETCH_RECIPES_USER';
export const FETCH_RECIPES_GROUP = 'FETCH_RECIPES_GROUP';
export const POST_RECIPE_GROUP = 'POST_RECIPE_GROUP';
export const PUT_RECIPE_GROUP = 'PUT_RECIPE_GROUP';
export const LOADING_RECIPES_USER = 'LOADING_RECIPES_USER';
export const LOADING_RECIPES_GROUP = 'LOADING_RECIPES_GROUP';
export const RECIPES_TRANSMISSIONS = 'RECIPES_TRANSMISSIONS';
